import { render, staticRenderFns } from "./apiTable.vue?vue&type=template&id=3976ade0&scoped=true&"
import script from "./apiTable.vue?vue&type=script&lang=js&"
export * from "./apiTable.vue?vue&type=script&lang=js&"
import style0 from "./apiTable.vue?vue&type=style&index=0&id=3976ade0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3976ade0",
  null
  
)

export default component.exports